import { Utilities } from 'src/app/common';
import { uId } from 'src/app/common/utilities';

export class TimeLine {
  id = null;
  empId = null;
  date = null;
  entries = [];
  currentEntry = null;
  timeLineEntryId = null;
  startTime = null;
  startedAt = null;
  endTime = null;
  endedAt = null;
  startedComment = null;
  endetComment = null;
  isOnPause = false;
  duration = null;
  change = false;
  nightDuration = 0;
  durationWithAdditionalHours = null;
  showNightShiftQuestion = false;
  includeNightDuration = false;
  showSundayShiftQuestion = false;
  includeSundayDuration = false;
  isVactionFromCalendar = null;
  longitude = null;
  latitude = null;
  endTravelDuration = null;
  startTravelDuration = null;
  startTimeLocationType = null;
  endTimeLocationType = null;
  device = 'Web';
  isVactionFromEmployee = false;
  additionalDuration = 0;
  constructionLocation = null;
  durationDifference = 0;
  home = null;
  office = null;
  travelDuration = 0;
  travelToConstructionDuration = 0;
  travelToOfficeDuration = 0;
  calcTravelTime = 1;
  project = null;
  fromAnotherOffice = null;
  ownOffice=null;
  checkShowTransportType = 1;
  transportTypeMode = null;
}

export class TimeLinePause {
  id = null;
  timeLineId = null;
  timeLineEntryId = null;
  startTime = null;
  startedAt = null;
  endTime = null;
  endedAt= null;
  startedComment = null;
  endetComment = null;
  addedFromSystem = null;
  duration = null;
}
class Project {
  duration = null;
  empId = null;
  date = null;
}
export class TimeTrackingViewModel {
  collectionViewModel = { projects: [], transportTypes: [{id: 'driving', name: 'Car'}, {id: 'transit', name: 'Bus/Train'}] };
  timeLine = new TimeLine();
  pauseTimeLines: TimeLinePause[] = [];
  timeLinePause = new TimeLinePause();
  timeTracking = null;
  timeFormat = '00:00';
  projectLines = [];
  summary = {
    timeWorked: '00:00',
    timeRemainProjects: '00:00',
    timePauses: '00:00',
    isValid: false,
    timeRemainNightProjects: '00:00:00',
    timeRemainSundayProjects: '00:00:00',
    isNightValid: false,
    isSundayValid: false,
  };
  isDayEnded = false;
  productiveHours = { duration: 0, nightDuration: 0, sundayDuration: 0 };
  nightDurationCalc = { nightDuration: 0 };
  nightSecPauses = 0;
  projects: Project[] = [];
  get(fromTravelTime = false, fromTrasnportType = false) {
    let startTime = Utilities.getFormatedDateTime(this.timeLine.startTime);
    let endTime = Utilities.getFormatedDateTime(this.timeLine.endTime);
    let temp: any = Object.assign({}, this.timeLine)

    temp.startTime = startTime;
    temp.endTime = endTime;
    temp.timeLineEntryId =
      temp.currentEntry?.id ?? temp.timeLineEntryId ?? null;
    temp.transportTypeMode = temp.transportTypeMode?.id;

    if(fromTravelTime){
      temp.calcTravelTime = 0;
    }
    if(fromTrasnportType){
      temp.checkShowTransportType = 0;
    }
    return temp;
  }

  applyCurrentEntry(currentEntry = this.timeLine.currentEntry) {
    this.timeLine.currentEntry = currentEntry ?? null;
    this.timeLine.timeLineEntryId = currentEntry?.id ?? null;

    if (!currentEntry) {
      this.timeLine.startTime = null;
      this.timeLine.startedAt = null;
      this.timeLine.endTime = null;
      this.timeLine.endedAt = null;
      this.timeLine.startedComment = null;
      this.timeLine.endetComment = null;
      this.timeLine.nightDuration = 0;
      this.timeLine.duration = 0;
      this.timeLine.durationWithAdditionalHours = 0;
      this.timeLine.startTravelDuration = 0;
      this.timeLine.endTravelDuration = 0;
      this.timeLine.includeNightDuration = false;
      this.timeLine.includeSundayDuration = false;
      this.timeLine.isOnPause = false;
      return;
    }

    this.timeLine.startTime = currentEntry.startTime
      ? Utilities.parseToTime(currentEntry.startTime)
      : null;
    this.timeLine.startedAt = currentEntry.startedAt
      ? Utilities.parseToTime(currentEntry.startedAt)
      : null;
    this.timeLine.endTime = currentEntry.endTime
      ? Utilities.parseToTime(currentEntry.endTime)
      : null;
    this.timeLine.endedAt = currentEntry.endedAt
      ? Utilities.parseToTime(currentEntry.endedAt)
      : null;
    this.timeLine.startedComment = currentEntry.startedComment;
    this.timeLine.endetComment = currentEntry.endetComment;
    this.timeLine.nightDuration = currentEntry.nightDuration ?? 0;
    this.timeLine.duration = currentEntry.duration ?? 0;
    this.timeLine.startTravelDuration = currentEntry.startTravelDuration ?? 0;
    this.timeLine.endTravelDuration = currentEntry.endTravelDuration ?? 0;
    this.timeLine.includeNightDuration = !!currentEntry.includeNightDuration;
    this.timeLine.includeSundayDuration = !!currentEntry.includeSundayDuration;
  }

  getEndTime() {
    const currentEntryId =
      this.timeLine.timeLineEntryId ?? this.timeLine.currentEntry?.id ?? null;
    var pauseTimeLinesFormated = [];
    this.pauseTimeLines.forEach((element) => {
      let object: any = Object.assign({}, element);
      object.startTime = Utilities.getFormatedDateTime(object.startTime);
      object.endTime = Utilities.getFormatedDateTime(object.endTime);
      object.timeLineEntryId = object.timeLineEntryId ?? currentEntryId;
      pauseTimeLinesFormated.push(object);
    });
    var projectLinesFormated = [];
    this.projectLines.forEach((element) => {
      var time: Date = Utilities.parseToTime(element.time);
      var duration = time.getHours() * 3600 + time.getMinutes() * 60;
      element.duration = duration;
      if(element.productiveHoursType == 'Night Hours' || element.productiveHoursType == 'Sunday Hours'){
        element.additionalDuration = duration / ( element.productiveHoursType == 'Sunday Hours' ? 1:2);
      }else{
        element.additionalDuration=0
      }
      element.type = element.project.type;
      var temp: any = Utilities.getFormatedObject(Object.assign({}, element));
      projectLinesFormated.push(temp);
    });
    this.isDayEnded = true;
    return {
      pauseTimeLines: pauseTimeLinesFormated,
      projectLines: projectLinesFormated,
      timeLine: this.get(),
    };
  }

  public calcSummary() {
    this.summary = {
      timeWorked: '00:00',
      timeRemainProjects: '00:00',
      timePauses: '00:00',
      isValid: false,
      timeRemainNightProjects: '00:00:00',
      timeRemainSundayProjects: '00:00:00',
      isNightValid: false,
      isSundayValid: false,
    }
    if (this.timeLine.endTime != null) {
      let started: any = Utilities.parseToTime(this.timeLine.startTime);
      let ended: any = Utilities.parseToTime(this.timeLine.endTime);
      if (started.getHours() > ended.getHours()) {
        this.calcSummaryWhenStartTimeIsBiggerThanEndTime(started, ended);
      } else {
        this.calcSummaryWhenStartTimeIsLowerThanEndTime(started, ended);
      }
      if (this.timeLine.includeNightDuration) {
        this.timeLine.nightDuration = this.calcNightHours(started, ended);
        this.timeLine.nightDuration -= this.calcSundayNightHours(
          started,
          ended
        );
      } else {
        this.timeLine.nightDuration = 0;
      }
    }

    var totalSeconds = this.calSecPauses();
    this.summary.timePauses = this.getTimeFormated(totalSeconds);
  }
  secondsToDate = (sec) => {
    sec =Math.abs(sec);
    let hours: any = Math.floor(sec / 3600);
    let minutes: any = Math.floor((sec % 3600) / 60);
    if (hours < -1) {
      minutes = Math.abs(minutes);
    }
    if (hours < 0 && minutes !== 0) {
      hours = hours + 1;
    }
    if (hours < 10 && hours >= 0) {
      hours = '0' + hours;
    }
    if (minutes < 10 && minutes >= 0) {
      minutes = '0' + minutes;
    }
    return new Date(new Date().toDateString() + ' ' + hours + ':' + minutes);
  };
  calcSundayNightHours(startTime, endTime) {
    let nightDuration = 0;
    if (new Date(startTime).getDay() == 6) {
      if (startTime.getHours() > endTime.getHours()) {
        if (endTime.getHours() <= 5) {
          nightDuration += endTime.getHours() * 60 * 60;
          nightDuration += endTime.getMinutes() * 60;
        } else {
          nightDuration += 6 * 60 * 60;
        }
      }
    }
    if (new Date(startTime).getDay() == 0) {
      if (startTime.getHours() > endTime.getHours()) {
        nightDuration += 2 * 60 * 60;
      } else if (endTime.getHours() == 22 || endTime.getHours() == 23) {
        if (endTime.getHours() == 22 && !(endTime.getHours() == 23)) {
          nightDuration += endTime.getMinutes() * 60;
        } else {
          nightDuration += 3600;
          nightDuration += endTime.getMinutes() * 60;
        }
      }
    }
    return nightDuration;
  }
  calcNightHours(startTime, endTime) {
    this.nightDurationCalc.nightDuration = 0;
    if (startTime.getHours() <= endTime.getHours()) {
      this.calcNightDurationWhenStartTimeIsLowerThanEndTime(startTime, endTime);
    } else {
      this.calcNightDurationWhenStartTimeIsBiggerThanEndTime(
        startTime,
        endTime
      );
    }
    return this.nightDurationCalc.nightDuration - this.calNightPauses();
  }
  calNightPauses() {
    this.nightSecPauses = 0;
    this.pauseTimeLines.forEach((element) => {
      if (element.endTime != null) {
        let hours = [1, 2, 3, 4, 5, 0, 22, 23];
        let started: any = Utilities.parseToTime(element.startTime);
        let endet: any = Utilities.parseToTime(element.endTime);
        if (
          hours.includes(started.getHours()) &&
          hours.includes(endet.getHours())
        ) {
          this.calcNightPausesWhenPauseIsInBetweenNightHours(started, endet);
        } else if (
          !hours.includes(started.getHours()) &&
          hours.includes(endet.getHours())
        ) {
          this.calcNightPausesWhenStartTimeIsNotInBetweenNightHours(endet);
        } else if (
          hours.includes(started.getHours()) &&
          !hours.includes(endet.getHours())
        ) {
          this.calcNightPausesWhenStartTimeIsInBetweenNightHours(started);
        }
      }
    });

    return this.nightSecPauses;
  }
  public deletePauseLine(detail) {
    var index = this.pauseTimeLines.indexOf(detail);
    this.pauseTimeLines.splice(index, 1);
    this.calcSummary();
  }

  public getSecondsProjectAssigned(night= false,sunday= false) {
    let projects = this.getDayProjects();
    if(night){
      projects = this.getNightProjects()
    }else if(sunday){
      projects = this.getSundayProjects()
    }


    var totalSeconds = 0;
    projects.forEach((element) => {
      if (element.time != null) {
        var time: Date = Utilities.parseToTime(element.time);
        var seconds = time.getHours() * 3600 + time.getMinutes() * 60;
        totalSeconds += seconds;
      }
    });

    return totalSeconds;
  }

  getTimeFormated(sec, addHAndM = false) {
    sec = Number(sec);
    var hours: any = Math.floor(sec / 3600);
    var minutes: any = Math.floor((sec % 3600) / 60);
    if (hours < -1) {
      minutes = Math.abs(minutes);
    }
    if (hours < 0 && minutes !== 0) {
      hours = hours + 1;
    }
    if (hours < 10 && hours >= 0) {
      hours = '0' + hours;
    }
    if (minutes < 10 && minutes >= 0) {
      minutes = '0' + minutes;
    }
    if (addHAndM) {
      return hours + 'h ' + minutes + 'm';
    } else {
      return hours + ':' + minutes;
    }
  }
  newPause() {
    var pauseDate = new Date(
      new Date().toDateString() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes() +
      ':00'
    );
    this.timeLinePause = new TimeLinePause();
    this.timeLinePause.timeLineId = this.timeLine.id;
    this.timeLinePause.timeLineEntryId =
      this.timeLine.timeLineEntryId ?? this.timeLine.currentEntry?.id ?? null;
    this.timeLinePause.startTime = pauseDate;

    this.timeLine.endTime = pauseDate;
    this.timeLine.isOnPause = true;
    var formatedObject = Utilities.getFormatedObject(
      Object.assign({}, this.timeLinePause)
    );
    formatedObject.startTime = Utilities.getFormatedDateTime(pauseDate);
    return formatedObject;
  }

  resume() {
    var pauseDate = new Date(
      new Date().toDateString() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes() +
      ':00'
    );

    this.timeLinePause.timeLineId = this.timeLine.id;

    this.timeLinePause.endTime = pauseDate;
    this.timeLine.endTime = null;
    this.timeLine.isOnPause = false;
    this.start();

    var formatedObject = Utilities.getFormatedObject(
      Object.assign({}, this.timeLinePause)
    );
    formatedObject.endTime = Utilities.getFormatedDateTime(pauseDate);
    formatedObject.startTime = Utilities.getFormatedDateTime(
      this.timeLinePause.startTime
    );
    return formatedObject;
  }

  getCurrentSegmentPauses(segStart: any, segEnd: any) {
    if (!segStart || !segEnd) return this.pauseTimeLines;
    return (this.pauseTimeLines || []).filter((p: any) => {
      if (!p?.startTime || !p?.endTime) return true;
      return this.pauseFullyInsideSegment(p, segStart, segEnd);
    });
  }
  pauseFullyInsideSegment(pause, segmentStart, segmentEnd): boolean {
    if (!pause?.startTime || !pause?.endTime || !segmentStart || !segmentEnd) {
      return false;
    }
    const ps = new Date(pause.startTime);
    const pe = new Date(pause.endTime);
    const ss = new Date(segmentStart);
    const se = new Date(segmentEnd);
    if (
      isNaN(ps.getTime()) || isNaN(pe.getTime()) ||
      isNaN(ss.getTime()) || isNaN(se.getTime())
    ) return false;
    const DAY = 86400;
    const tod = (d: Date) =>
      d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
    const ssT = tod(ss);
    let seT = tod(se);
    const segmentCrossesMidnight = ssT > seT;
    if (segmentCrossesMidnight) seT += DAY;
    let psT = tod(ps);
    let peT = tod(pe);
    if (psT > peT) peT += DAY;
    if (segmentCrossesMidnight && psT < ssT) {
      psT += DAY;
      peT += DAY;
    }
    return psT >= ssT && peT <= seT && psT <= peT;
  }
  calSecPauses(pauses = this.pauseTimeLines) {
    var total = 0;
    pauses.forEach((element) => {
      if (element.endTime != null) {
        var started: any = Utilities.parseToTime(element.startTime);
        var endet: any = Utilities.parseToTime(element.endTime);
        total += Math.abs(
          Math.round((endet.getTime() - started.getTime()) / 1000)
        );
        if (started > endet) {
          total -= Math.abs(
            Math.round((endet.getTime() - started.getTime()) / 1000)
          );
          endet.setDate(endet.getDate() + 1);
          total += Math.abs(
            Math.round((endet.getTime() - started.getTime()) / 1000)
          );
          endet.setDate(endet.getDate() - 1);
        }
      }
    });

    return total;
  }
  checkOneOfPauseMoreThan30Min(){
    if(this.pauseTimeLines.length > 1 ){
      let moreThan30min = true;
      this.pauseTimeLines.forEach((pause) => {
        if(this.calSecPauses([pause]) >= 1800){
          moreThan30min = false;
        }
      });
      return moreThan30min;
    }
    return false;
  }
  start() {
    var myVar = setInterval(() => {
      if (this.timeLine.isOnPause) {
        clearInterval(myVar);
      }
      if (this.timeLine.startTime) {
        var now: any = this.timeLine.isOnPause
          ? Utilities.parseToTime(this.timeLinePause.startTime)
          : new Date();

        var started: any = Utilities.parseToTime(this.timeLine.startTime);
        var secondBetweenTwoDate = Math.abs(
          Math.round((now.getTime() - started.getTime()) / 1000)
        );

        const segmentPauses = this.pauseTimeLines.filter((p: any) => {
          if (!p?.endTime || !p?.startTime) return false;
          const ps = Utilities.parseToTime(p.startTime).getTime();
          const pe = Utilities.parseToTime(p.endTime).getTime();
          return ps >= started.getTime() && pe <= now.getTime();
        });

        this.timeTracking =
          secondBetweenTwoDate -
          this.calSecPauses(segmentPauses) +
          this.timeLine.startTravelDuration +
          this.timeLine.endTravelDuration;
        this.timeFormat = this.getTimeFormated(this.timeTracking);
      }
    }, 1000);
  }

  addProjectLine(duration = 0, fromNightProject = false, fromSundayProject= false) {
    if (
      this.timeLine.duration -
      this.getSecondsProjectAssigned() <
      0
    )
      return;
    let baseDate = new Date().toDateString();
    let timeString: string;

    if (fromNightProject) {
      timeString = duration
        ? this.getTimeFormated(duration)
        : this.summary.timeRemainNightProjects;
    } else if (fromSundayProject) {
      timeString = duration
        ? this.getTimeFormated(duration)
        : this.summary.timeRemainSundayProjects;
    } else {
      timeString = duration
        ? this.getTimeFormated(duration)
        : this.summary.timeRemainProjects;
    }

    let time = new Date(`${baseDate} ${timeString}`);

    this.projectLines.push({
      timeLineId: this.timeLine.id,
      project: null,
      time,
      id: uId(),
      additionalDuration: (fromNightProject||fromSundayProject) ? Utilities.getTimeFormated(Utilities.fromDateToDuartion(time) / (fromSundayProject? 1: 2)) : 0,
      productiveHoursType: fromNightProject ? 'Night Hours':fromSundayProject?'Sunday Hours':'Regular working hours',
      duration: null,
    });
    this.calcSummary();
  }

  addBreakLine() {
    var timeLinePause = new TimeLinePause();
    this.pauseTimeLines.push(timeLinePause);
  }

  deleteProjectLine(detail) {
    var index = this.projectLines.indexOf(detail);
    this.projectLines.splice(index, 1);
    this.calcSummary();
  }

  startPauseTime(timeLinePause) {
    timeLinePause.startTime = Utilities.parseToTime(timeLinePause.startTime);
    timeLinePause.endTime = Utilities.parseToTime(timeLinePause.endTime);

    this.timeLinePause = timeLinePause;
    this.pauseTimeLines.push(timeLinePause);
  }

  set(timeLine, pauses, entries = [], currentEntry = null) {
    this.timeLine = {...this.timeLine, ...timeLine };
    this.timeLine.entries = entries ?? [];
    this.timeLine.currentEntry = currentEntry ?? null;
    this.timeLine.timeLineEntryId = currentEntry?.id ?? null;
    this.pauseTimeLines = pauses;

    if (this.pauseTimeLines.length > 0) {
      this.pauseTimeLines.forEach((element) => {
        element.startTime = Utilities.parseToTime(element.startTime);
        element.endTime = Utilities.parseToTime(element.endTime);
      });

      this.timeLinePause = this.pauseTimeLines[this.pauseTimeLines.length - 1];
    }

    this.applyCurrentEntry(this.timeLine.currentEntry);

    if (this.timeLine.currentEntry && (this.timeLine.isOnPause || this.timeLine.endTime == null)) {
      this.isDayEnded = false;
      this.start();
    } else if (this.timeLine.currentEntry && this.timeLine.endTime != null) {
      this.isDayEnded = true;
      var started: any = Utilities.parseToTime(this.timeLine.startTime);
      var ended: any = Utilities.parseToTime(this.timeLine.endTime);
      var secondBetweenTwoDate = Math.abs(
        Math.round((ended.getTime() - started.getTime()) / 1000)
      );

      const segmentPauses = this.pauseTimeLines.filter((p: any) => {
        if (!p?.endTime || !p?.startTime) return false;
        const ps = Utilities.parseToTime(p.startTime).getTime();
        const pe = Utilities.parseToTime(p.endTime).getTime();
        return ps >= started.getTime() && pe <= ended.getTime();
      });

      var timeTracking =
        secondBetweenTwoDate -
        this.calSecPauses(segmentPauses) +
        this.timeLine.startTravelDuration +
        this.timeLine.endTravelDuration;
      this.timeFormat = this.getTimeFormated(timeTracking);
    } else {
      this.isDayEnded = false;
      this.timeFormat = '00:00';
    }
  }
  setToDefault() {
    this.timeLine = new TimeLine();
    this.pauseTimeLines = [];
    this.timeLinePause = new TimeLinePause();
    this.timeTracking = null;
    this.timeFormat = '00:00';
    this.projectLines = [];
    this.summary = {
      timeWorked: '00:00',
      timeRemainProjects: '00:00',
      timePauses: '00:00',
      isValid: false,
      timeRemainNightProjects: '00:00:00',
      timeRemainSundayProjects: '00:00:00',
      isNightValid: false,
      isSundayValid: false,
    };
    this.isDayEnded = false;
  }
  calcProductiveDailyHours(timeLine) {
    let total = 0;
    if (this.timeLineIsValid(timeLine)) {
      timeLine.startTime = new Date(timeLine.startTime);
      timeLine.endTime = new Date(timeLine.endTime);
      this.productiveHours.nightDuration = 0;
      this.productiveHours.duration = timeLine.duration;
      this.productiveHours.sundayDuration = 0;
      if (timeLine.includeSundayDuration) {
        this.calcProuctiveSundayDailyHours(timeLine);
      }

      if (timeLine.startTime.getHours() <= timeLine.endTime.getHours()) {
        this.calcProductiveDailyHoursWhenStartTimeIsLowerThanEndTime(timeLine);
      } else {
        this.calcProductiveDailyHoursWhenStartTimeIsBiggerThanEndTime(timeLine);
      }
      let nightSecPauses =
        this.calNightPauses() + this.calcSundayPauses(timeLine);
      this.productiveHours.nightDuration -= this.calcSundayNightHours(
        new Date(timeLine.startTime),
        new Date(timeLine.endTime)
      );
      this.productiveHours.duration =
        timeLine.duration -
        this.productiveHours.sundayDuration +
        this.calcSundayPauses(timeLine) -
        this.productiveHours.nightDuration +
        nightSecPauses;
      total +=
        (this.productiveHours.nightDuration - nightSecPauses) *
        (timeLine.includeNightDuration ? 1.5 : 1);
      if (timeLine.isVactionFromCalendar?.type === 'Gesetzlicher Feiertag') {
        total +=
          this.productiveHours.duration *
          (timeLine.includeSundayDuration ? 2 : 1);
      } else {
        total += this.productiveHours.duration;
      }
      total +=
        (this.productiveHours.sundayDuration -
          this.calcSundayPauses(timeLine)) *
        (timeLine.includeSundayDuration ? 2 : 1);
    }
    return total;
  }
  calcSundayPauses(timeLine) {
    let total = 0;
    let started = null;
    let endet = null;
    if (new Date(timeLine.startTime).getDay() == 6) {
      console.log(timeLine.pauses);
      this.pauseTimeLines.forEach((pause) => {
        started = Utilities.parseToTime(pause.startTime);
        endet = Utilities.parseToTime(pause.endTime);
        if (
          endet != null &&
          new Date(started).getHours() >= 0 &&
          new Date(started).getHours() <= 8
        ) {
          total += Math.abs(
            Math.round((endet.getTime() - started.getTime()) / 1000)
          );
        }
      });
    }
    // if (new Date(timeLine.startTime).getDay() == 0) {
    //   timeLine.pauses.forEach((pause) => {
    //   started  = Utilities.parseToTime(pause.startTime);
    //   endet = Utilities.parseToTime(pause.endTime);
    //   if (started > endet) {
    //     total += Math.abs(
    //       Math.round((endet.getTime() - started.getTime()) / 1000)
    //     );
    //   }});
    // }
    return total;
  }
  calcSummaryWhenStartTimeIsLowerThanEndTime = (started, ended) => {
    ended = new Date(
      started.toDateString() +
      ' ' +
      ended.getHours() +
      ':' +
      ended.getMinutes() +
      ':' +
      ended.getSeconds()
    );
    var secondBetweenTwoDate = Math.abs(
      Math.round((ended.getTime() - started.getTime()) / 1000)
    );

    const segmentPauses = this.getCurrentSegmentPauses(started, ended);
    var timeTracking = secondBetweenTwoDate - this.calSecPauses(segmentPauses);

    this.timeLine.duration = timeTracking;
    let durationWithAdditionalHours = this.calcProductiveDailyHours(
      this.timeLine
    );
    this.timeLine.durationWithAdditionalHours = durationWithAdditionalHours;

    this.summary.timeWorked = this.getTimeFormated(timeTracking);

    this.summary.timeRemainProjects = this.getTimeFormated(
      timeTracking -this.timeLine.nightDuration - this.productiveHours.sundayDuration - this.getSecondsProjectAssigned()
    );
    this.summary.isValid = this.summary.timeRemainProjects == '00:00'
    this.summary.timeRemainNightProjects = this.getTimeFormated(
      this.timeLine.nightDuration - this.getSecondsProjectAssigned(true)
    );
    this.summary.isNightValid = this.summary.timeRemainNightProjects == '00:00'
    this.summary.timeRemainSundayProjects = this.getTimeFormated(
      this.productiveHours.sundayDuration - this.getSecondsProjectAssigned(false, true)
    );
    console.log(this.productiveHours.sundayDuration );
    this.summary.isSundayValid = this.summary.timeRemainSundayProjects == '00:00'
    this.timeFormat = this.getTimeFormated(timeTracking);
  };
  calcSummaryWhenStartTimeIsBiggerThanEndTime(started, ended) {
    let date = new Date(started.toDateString() + ' 24:00:00');
    let endedDate = new Date(ended.toDateString() + ' 00:00:00');
    let secondBetweenTwoDate = Math.abs(
      Math.round((started.getTime() - date.getTime()) / 1000)
    );

    secondBetweenTwoDate += Math.abs(
      Math.round((endedDate.getTime() - ended.getTime()) / 1000)
    );
    const segmentPauses = this.getCurrentSegmentPauses(started, ended);
    var timeTracking = secondBetweenTwoDate - this.calSecPauses(segmentPauses);

    this.timeLine.duration = timeTracking;
    let durationWithAdditionalHours = this.calcProductiveDailyHours(
      this.timeLine
    );

    this.timeLine.durationWithAdditionalHours = durationWithAdditionalHours;
    this.summary.timeWorked = this.getTimeFormated(timeTracking);
    this.summary.timeRemainProjects = this.getTimeFormated(
      timeTracking - this.timeLine.nightDuration - this.productiveHours.sundayDuration - this.getSecondsProjectAssigned()
    );
    this.summary.isValid = this.summary.timeRemainProjects == '00:00'
    this.summary.timeRemainNightProjects = this.getTimeFormated(
      this.timeLine.nightDuration - this.getSecondsProjectAssigned(true)
    );
    this.summary.isNightValid = this.summary.timeRemainNightProjects == '00:00'
    this.summary.timeRemainSundayProjects = this.getTimeFormated(
      this.productiveHours.sundayDuration - this.getSecondsProjectAssigned(false, true)
    );
    this.summary.isSundayValid = this.summary.timeRemainSundayProjects == '00:00'
    this.timeFormat = this.getTimeFormated(timeTracking);
  }
  calcProductiveDailyHoursWhenStartTimeIsLowerThanEndTime = (timeLine) => {
    let hours = [1, 2, 3, 4, 5, 0, 22, 23, 24];
    let timeWorked =
      timeLine.endTime.getHours() - timeLine.startTime.getHours();
    let timeLineArr = Array.from(Array(timeWorked + 1).keys());
    timeLineArr = timeLineArr.map((a) => {
      return (a = a + timeLine.startTime.getHours());
    });
    timeLineArr.forEach((hourWork) => {
      hours.forEach((nightHourWork) => {
        if (nightHourWork == hourWork) {
          this.productiveHours.nightDuration += 3600;
          if (timeLine.endTime.getHours() == hourWork) {
            this.productiveHours.nightDuration -= 3600;
            this.productiveHours.nightDuration +=
              timeLine.endTime.getMinutes() * 60;
          }
          if (timeLine.startTime.getHours() == hourWork) {
            this.productiveHours.nightDuration -=
              timeLine.startTime.getMinutes() * 60;
          }
        }
      });
    });
  };
  calcProductiveDailyHoursWhenStartTimeIsBiggerThanEndTime = (timeLine) => {
    let hours = [1, 2, 3, 4, 5, 0, 22, 23, 24];
    let timeWorked = 24 - timeLine.startTime.getHours();
    let timeLineArr = Array.from(Array(timeWorked + 1).keys());
    timeLineArr = timeLineArr.map((a) => {
      return a + timeLine.startTime.getHours();
    });

    timeLineArr.forEach((hourWork) => {
      hours.forEach((nightHourWork) => {
        if (nightHourWork == hourWork) {
          this.productiveHours.nightDuration += 3600;

          if (timeLine.startTime.getHours() == hourWork) {
            this.productiveHours.nightDuration -= 3600;
            this.productiveHours.nightDuration -=
              timeLine.startTime.getMinutes() * 60;
          }
        }
      });
    });
    if (timeLineArr.includes(21)) {
      this.productiveHours.nightDuration -= 3600;
    }
    timeLineArr = Array.from(
      Array(
        timeLine.endTime.getHours() === 0 ? 1 : timeLine.endTime.getHours() + 1
      ).keys()
    );
    timeLineArr.forEach((hourWork) => {
      hours.forEach((nightHourWork) => {
        if (nightHourWork == hourWork) {
          this.productiveHours.nightDuration += 3600;
          if (timeLine.endTime.getHours() == hourWork) {
            this.productiveHours.nightDuration -= 3600;
            this.productiveHours.nightDuration +=
              timeLine.endTime.getMinutes() * 60;
          }
        }
      });
    });
  };
  calcProuctiveSundayDailyHours = (timeLine) => {
    const isPublicHoliday =
      this.timeLine.includeSundayDuration &&
      this.timeLine.isVactionFromCalendar?.type === 'Gesetzlicher Feiertag';
    if (isPublicHoliday) {
      this.productiveHours.sundayDuration = timeLine.duration;
      return;
    }
    if (
      timeLine.startTime.getDay() === 6 &&
      timeLine.startTime.getHours() > timeLine.endTime.getHours()
    ) {
      this.productiveHours.sundayDuration +=
        timeLine.endTime.getHours() * 60 * 60 +
        timeLine.endTime.getMinutes() * 60;
    }
    if (timeLine.startTime.getDay() === 0) {
      if (timeLine.startTime.getHours() > timeLine.endTime.getHours()) {
        this.productiveHours.sundayDuration -=
          timeLine.endTime.getHours() * 60 * 60;
        this.productiveHours.sundayDuration -=
          timeLine.endTime.getMinutes() * 60;
        this.productiveHours.sundayDuration += this.calcMondayPause();
      }
      this.productiveHours.sundayDuration += timeLine.duration;
    }
  };
  calcMondayPause() {
    let total = 0;
    this.pauseTimeLines?.forEach((pause) => {
      let started = Utilities.parseToTime(pause.startTime);
      let endet = Utilities.parseToTime(pause.endTime);
      if (
        endet != null &&
        new Date(started).getHours() >= 0 &&
        new Date(started).getHours() <= 8
      ) {
        total += Math.abs(
          Math.round((endet.getTime() - started.getTime()) / 1000)
        );
      }
    });
    return total;
  }
  calcNightDurationWhenStartTimeIsLowerThanEndTime = (startTime, endTime) => {
    let hours = [1, 2, 3, 4, 5, 0, 22, 23, 24];
    let timeWorked = endTime.getHours() - startTime.getHours();
    let timeLineArr = Array.from(Array(timeWorked + 1).keys());
    timeLineArr = timeLineArr.map((a) => {
      return (a = a + startTime.getHours());
    });
    timeLineArr.forEach((hourWork) => {
      hours.forEach((nightHourWork) => {
        if (nightHourWork == hourWork) {
          this.nightDurationCalc.nightDuration += 3600;
          if (endTime.getHours() == hourWork) {
            this.nightDurationCalc.nightDuration -= 3600;
            this.nightDurationCalc.nightDuration += endTime.getMinutes() * 60;
          }
          if (startTime.getHours() == hourWork) {
            this.nightDurationCalc.nightDuration -= startTime.getMinutes() * 60;
          }
        }
      });
    });
  };
  calcNightDurationWhenStartTimeIsBiggerThanEndTime = (startTime, endTime) => {
    let hours = [1, 2, 3, 4, 5, 0, 22, 23, 24];
    let timeWorked = 24 - startTime.getHours();
    let timeLineArr = Array.from(Array(timeWorked + 1).keys());
    timeLineArr = timeLineArr.map((a) => {
      return a + this.timeLine.startTime.getHours();
    });
    timeLineArr.forEach((hourWork) => {
      hours.forEach((nightHourWork) => {
        if (nightHourWork == hourWork) {
          this.nightDurationCalc.nightDuration += 3600;

          if (this.timeLine.startTime.getHours() == hourWork) {
            this.nightDurationCalc.nightDuration -= 3600;
            this.nightDurationCalc.nightDuration -=
              this.timeLine.startTime.getMinutes() * 60;
          }
        }
      });
    });
    if (timeLineArr.includes(21)) {
      this.nightDurationCalc.nightDuration -= 3600;
    }
    timeLineArr = Array.from(
      Array(endTime.getHours() === 0 ? 1 : endTime.getHours() + 1).keys()
    );
    timeLineArr.forEach((hourWork) => {
      hours.forEach((nightHourWork) => {
        if (nightHourWork == hourWork) {
          this.nightDurationCalc.nightDuration += 3600;
          if (this.timeLine.endTime.getHours() == hourWork) {
            this.nightDurationCalc.nightDuration -= 3600;
            this.nightDurationCalc.nightDuration +=
              this.timeLine.endTime.getMinutes() * 60;
          }
        }
      });
    });
  };
  timeLineIsValid = (timeLine) => {
    return (
      timeLine.startTime &&
      timeLine.endTime &&
      timeLine.startTime !== '00:00' &&
      timeLine.startTime !== '01:00'
    );
  };
  calcNightPausesWhenPauseIsInBetweenNightHours = (started, endet) => {
    let secondBetweenTwoDate = Math.abs(
      Math.round((endet.getTime() - started.getTime()) / 1000)
    );
    if (secondBetweenTwoDate > 7200) {
      endet.setDate(endet.getDate() + 1);
      secondBetweenTwoDate = Math.abs(
        Math.round((endet.getTime() - started.getTime()) / 1000)
      );
      endet.setDate(endet.getDate() - 1);
    }
    this.nightSecPauses += secondBetweenTwoDate;
  };
  calcNightPausesWhenStartTimeIsNotInBetweenNightHours = (endet) => {
    let startNightShift = new Date(endet.toDateString() + ' 22:00');
    let secondBetweenTwoDate = Math.abs(
      Math.round((endet.getTime() - startNightShift.getTime()) / 1000)
    );
    if (secondBetweenTwoDate > 7200) {
      endet.setDate(endet.getDate() - 1);
      startNightShift = new Date(endet.toDateString() + ' 22:00');
      endet.setDate(endet.getDate() + 1);
      secondBetweenTwoDate = Math.abs(
        Math.round((endet.getTime() - startNightShift.getTime()) / 1000)
      );
    }
    this.nightSecPauses += secondBetweenTwoDate;
  };
  calcNightPausesWhenStartTimeIsInBetweenNightHours = (started) => {
    let endNightShift = new Date(started.toDateString() + ' 06:00');
    let secondBetweenTwoDate = Math.abs(
      Math.round((endNightShift.getTime() - started.getTime()) / 1000)
    );
    this.nightSecPauses += secondBetweenTwoDate;
  };
  showNightShiftQuestion(timeLine) {
    let nightShiftsHours = [22, 23, 0, 1, 2, 3, 4, 5];
    let startHour = timeLine.startTime.getHours();
    let endHour = timeLine.endTime.getHours();
    if (nightShiftsHours.includes(startHour)) return true;
    if (nightShiftsHours.includes(endHour)) return true;
    if (startHour > endHour) return true;
    return false;
  }
  showSundayShiftQuestion(timeLine, isVactionFromCalendar) {
    let day = timeLine.startTime.getDay();
    if (day == 0) return true;
    let startHour = timeLine.startTime.getHours();
    let endHour = timeLine.endTime.getHours();
    if (day == 6 && startHour > endHour) return true;
    if (
      isVactionFromCalendar &&
      isVactionFromCalendar.type == 'Gesetzlicher Feiertag'
    )
      return true;
    return false;
  }

  addPause() {
    let secPause = this.calSecPauses();
    const fiveHoursAndHalfHors = 19800;
    const sevenHours = 25260;
    let minuteAdded = 0;
    minuteAdded = this.addPauseInTheMiddle(fiveHoursAndHalfHors, sevenHours, 15,15, secPause)
    if(minuteAdded) return minuteAdded;
    const eightHours = 28800;
    minuteAdded = this.addPauseInTheMiddle(sevenHours, eightHours, 30,30, secPause)
    if(minuteAdded) return minuteAdded;

    const nineHours = 32400;
    minuteAdded = this.addPauseInTheMiddle(eightHours, nineHours, 30,60, secPause)
    if(minuteAdded) return minuteAdded;

    minuteAdded = this.addPauseInTheMiddle(nineHours, 86400, 60,60, secPause)
    if(minuteAdded) return minuteAdded;
    return minuteAdded;
  }
  addPauseInTheMiddle(start, end, minShouldHave, minuteToAdd, secPause) {
    if ((this.timeLine.duration + secPause) >= start && (this.timeLine.duration + secPause) < end) {
      return minShouldHave;
    }
    return 0;
  }
  checkIfLunchPauseExist() {
    return this.pauseTimeLines.find(
      (pause) =>
        pause.startTime.getHours() == 12 ||
        (pause.startTime.getHours() <= 12 && pause.endTime.getHours() >= 13) ||
        (pause.startTime.getHours() <= 12 &&
          pause.endTime.getHours() == 12 &&
          pause.endTime.getMinutes() > 0)
    );
  }
  getNightProjects() {
    return this.projectLines.filter((project) => project.productiveHoursType === 'Night Hours')
  }
  getDayProjects() {
    return this.projectLines.filter((project) => project.productiveHoursType !== 'Night Hours' && project.productiveHoursType !== 'Sunday Hours')
  }
  getSundayProjects() {
    return this.projectLines.filter((project) => project.productiveHoursType === 'Sunday Hours')
  }
  updateAdditionalDuration(line) {
    line.additionalDuration = Utilities.getTimeFormated(Utilities.fromDateToDuartion(line.time)/ (line.productiveHoursType == 'Sunday Hours' ? 1 : 2))
  }

  isSundayOrHoliday(): boolean {
    if (!this.timeLine?.startTime) return false;
    const day = new Date(this.timeLine.startTime).getDay();
    const isHoliday =
      this.timeLine.isVactionFromCalendar?.type === 'Gesetzlicher Feiertag';
    return day === 0 || isHoliday;
  }

  reassignProjectLinesForCategory(category: 'sunday' | 'night') {
    const targetType = category === 'sunday' ? 'Sunday Hours' : 'Night Hours';
    const include =
      category === 'sunday'
        ? !!this.timeLine?.includeSundayDuration
        : !!this.timeLine?.includeNightDuration;
    const isEligibleDay =
      category === 'sunday' ? this.isSundayOrHoliday() : true;

    this.projectLines.forEach((line) => {
      if (include && isEligibleDay) {
        if (line.productiveHoursType === 'Regular working hours') {
          line.productiveHoursType = targetType;
          this.updateAdditionalDuration(line);
        }
      } else {
        if (line.productiveHoursType === targetType) {
          line.productiveHoursType = 'Regular working hours';
          line.additionalDuration = 0;
        }
      }
    });
  }
}
